import { CHECK_STATUS } from '../types';
import { getWifiStatus, getEthernetLink, resetNetworkStatusCache } from '@upshow/brightsign/src';

export const id = 'brightsignWifiSignal';
export const label = 'WiFi Signal';

const PASS_FLOOR_DBM = -67;
const AT_RISK_FLOOR_DBM = -80;

function bandFor (signalStrength) {
  if (signalStrength >= PASS_FLOOR_DBM) return { status: CHECK_STATUS.PASS, detail: 'Strong signal' };
  if (signalStrength >= AT_RISK_FLOOR_DBM) return { status: CHECK_STATUS.AT_RISK, detail: 'Weak signal — streaming may buffer' };
  return { status: CHECK_STATUS.FAIL, detail: 'Signal too weak for streaming' };
}

export async function run (_ctx) {
  const start = Date.now();
  // Drop the shared instance so a re-run reads live state, not cached readings.
  resetNetworkStatusCache();
  const ethernet = await getEthernetLink();

  if (ethernet.available && ethernet.hasLink) {
    return {
      id,
      label,
      status: CHECK_STATUS.SKIPPED,
      detail: 'Not applicable — connected via Ethernet',
      detailData: { notChecked: true, reason: 'ethernet link active' },
      durationMs: Date.now() - start,
    };
  }

  const wifi = await getWifiStatus();
  const durationMs = Date.now() - start;

  // A disconnected WiFi interface can still report a stale/leftover signalStrength
  // number — require `connected` too, so a dead interface can't pass on old data.
  if (!wifi.available || !wifi.connected || typeof wifi.signalStrength !== 'number') {
    return {
      id,
      label,
      status: CHECK_STATUS.SKIPPED,
      detail: 'Not checked — signal unavailable on this firmware',
      detailData: {
        notChecked: true,
        reason: wifi.reason || (wifi.available && !wifi.connected ? 'wifi interface not connected' : 'signalStrength unavailable'),
      },
      durationMs,
    };
  }

  const { status, detail } = bandFor(wifi.signalStrength);
  return {
    id,
    label,
    status,
    detail,
    detailData: { signalStrengthDbm: wifi.signalStrength, essid: wifi.essid, uncalibrated: true },
    durationMs,
  };
}
